let _ = t => t,
  _t;
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { GREAT_WHITE, OLAF, KOALA } from 'HubStyleTokens/colors';
import UITable from 'UIComponents/table/UITable';
import { getCompareApiNamesSelector, getCompareFeaturesSelector } from '../../selectors/CompareSelectors';
import CompareSelect from './CompareSelect';
import FeatureTableRow from '../feature-table/FeatureTableRow';
import { SectionTitle } from '../common/SharedComponents';
import Breakpoints from '../../constants/Breakpoints';
import { ContainerStyles, TableStyles } from './CompareStyles';
import ComparePageStatusFooter from './ComparePageStatusFooter';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import classNames from 'pricing-pages-ui/utils/classNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TableContainer = styled.div.withConfig({
  displayName: "CompareTable__TableContainer",
  componentId: "sc-1yqscn-0"
})(["", ""], ContainerStyles);
const StyledTable = styled(UITable).withConfig({
  displayName: "CompareTable__StyledTable",
  componentId: "sc-1yqscn-1"
})(["", ""], TableStyles);
const THead = styled.thead.withConfig({
  displayName: "CompareTable__THead",
  componentId: "sc-1yqscn-2"
})(["& tr th{background-color:transparent;border:1px solid ", ";font-size:0.875rem;text-align:center;white-space:nowrap;}"], GREAT_WHITE);
const TBody = styled.tbody.withConfig({
  displayName: "CompareTable__TBody",
  componentId: "sc-1yqscn-3"
})(["& tr > *{border:1px solid ", ";}& tr td{text-align:center;}& tr th[scope='row']{padding:16px 24px;", "}"], GREAT_WHITE, Breakpoints.phoneLarge(_t || (_t = _`
      padding: 16px 0;
    `)));
const StickyFooter = styled.div.withConfig({
  displayName: "CompareTable__StickyFooter",
  componentId: "sc-1yqscn-4"
})(["width:100%;z-index:100;background-color:", ";position:sticky;bottom:-1px;padding-bottom:1px;&.is-sticky{border-top:1px solid ", ";}"], OLAF, KOALA);
const CompareTable = () => {
  const features = useSelector(getCompareFeaturesSelector);
  const highlightedProducts = useSelector(getCompareApiNamesSelector);
  if (!features.length || !highlightedProducts.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableContainer, {
      children: /*#__PURE__*/_jsxs(StyledTable, {
        flush: true,
        bordered: true,
        columns: highlightedProducts.length + 1,
        children: [/*#__PURE__*/_jsx(THead, {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(SectionTitle, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.productCatalog.tableHeader.features"
                })
              })
            }), highlightedProducts.map(apiName => {
              return /*#__PURE__*/_jsx("th", {
                scope: "col",
                children: /*#__PURE__*/_jsx(CompareSelect, {
                  apiName: apiName
                })
              }, apiName);
            })]
          })
        }), /*#__PURE__*/_jsx(TBody, {
          children: features.map(feature => {
            return /*#__PURE__*/_jsx(FeatureTableRow, {
              highlightedProducts: highlightedProducts,
              feature: feature,
              onlyShowCurrentLongLimit: true
            }, feature.featureId);
          })
        })]
      })
    }), /*#__PURE__*/_jsx(UIIntersectionObserver, {
      threshold: 1,
      renderContent: isIntersecting => /*#__PURE__*/_jsx(StickyFooter, {
        className: classNames(!isIntersecting && 'is-sticky'),
        children: /*#__PURE__*/_jsx(TableContainer, {
          children: /*#__PURE__*/_jsx(ComparePageStatusFooter, {
            highlightedProducts: highlightedProducts
          })
        })
      })
    })]
  });
};
export default CompareTable;